// based on https://www.npmjs.com/package/dlv
export const getNestedPropertyOrDefault = (
  obj: any,
  key: any,
  def?: any,
  p?: any,
  undef?: any,
) => {
  key = key && key.split ? key.split('.') : [key];
  for (p = 0; p < key.length; p++) {
    obj = obj ? obj[key[p]] : undef;
  }
  return obj === undef ? def : obj;
};
